<template>
    <v-layout>
        <form
        id="auth1xForm"
        @submit="checkForm"
        :action="acsURL"
        method="post"
        novalidate="true"
        >
        <input type="hidden" name="MD" :value="MD" />
        <input type="hidden" name="PaReq" :value="PaReq" />
        <input type="hidden" name="TermUrl" :value="TermUrl" />
        </form>
        <form
        id="authForm2auth"
        @submit="checkForm"
        :action="acsURL"
        method="post"
        novalidate="true"
        >
        <input type="hidden" name="creq" :value="creq" />
        </form>
    </v-layout>
</template>
<script>

export default {
    name: 'TpvAuth'   ,
    data: () => ({
        result: "",
        acsURL: "",
        MD: "",
        PaReq: "",
        creq: "",
        //TermUrl: "https://b2b.fiehisa.org/tpvAuth"
        TermUrl: "https://b2b.fiehisa.org/proxy"
    }),
    methods: {
        checkForm: function (e) {
            e.preventDefault();
        }
    },
    components:{
        
    },
    mounted()
    {
        let uri = window.location.href.split('?');
        if (uri.length == 2)
        {
            let vars = uri[1].split('&');
            let getVars = {};
            let tmp = '';
            vars.forEach(function(v){
                tmp = v.split('=');
                if(tmp.length == 2)
                getVars[tmp[0]] = tmp[1];
            });
            //console.log(getVars);
            var pedidoNAV = this.$store.state.dialogPaymentData.order;
            if (getVars['res']!=undefined){
                this.result = getVars['res'];
                if (this.result == 'ok'){
                     this.$fire({
                        title: "Pago procesado correctamente",
                        text: "Pedido nº " + pedidoNAV,
                        type: "success"
                    }).then(r => {
                        //console.log(r.value);
                        this.$router.push("menu");
                    });
                } else {
                    this.$fire({
                        title: "Oops...",
                        text: "Su pedido se ha creado pero algo ha ido mal en el proceso de pago.",
                        type: "error",
                        showCancelButton: false,
                        confirmButtonText: `OK`,
                        cancelButtonText: `Volver`,
                        allowOutsideClick: false
                    }).then(r => {
                        //console.log(r);
                        if (r.dismiss == 'cancel'){
                            this.$router.push("menu");
                        } else if (r.value){
                            ///this.setPaymentDialog(this.getDocTitle() + ' creado','Se ha creado el ' + this.getDocTitle().toLowerCase()  + ' nº ' + this.$store.state.dialogPaymentData.order + ' en el sistema. ¿Desea pagarlo con tarjeta?',this.$store.state.dialogPaymentData.order,this.$store.state.dialogPaymentData.total);
                            this.$store.state.dialogPayment = true;
                        }
                    });
                }
            }
            if (getVars['a']!=undefined){
                if (this.$store.state.usuario.oneclick)
                    this.$store.commit("setUserA",getVars['a']);
                else 
                    this.$store.commit("setUserA",'');
            }
            if (getVars['params']!=undefined){
                var decodedURLparm = decodeURIComponent(getVars['params']);
                var decodedParmsString = atob(decodedURLparm);
                //console.log(decodedParmsString);
                var decodedParmsJson = JSON.parse(decodedParmsString);
                //console.log(decodedParmsJson);
                this.acsURL = decodedParmsJson.Ds_EMV3DS.acsURL;
                //this.MD = decodedParmsJson.Ds_EMV3DS.MD;
                //this.PaReq = decodedParmsJson.Ds_EMV3DS.PAReq;
                this.creq = decodedParmsJson.Ds_EMV3DS.creq;
                var f = document.getElementById("authForm2auth");//.submit();
                setTimeout(function(){ 
                    f.submit(); 
                }, 500);
                // do 
            }
        }
    },
}
</script>
<style>
body {
  font-family: "Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", Helvetica, Arial, sans-serif; 
}
</style>